import template from './employee_attendance_report.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeAttendanceViewModel
{
	constructor (page)
	{
		this.page = page;

		this.date_start_filter = ko.observable(moment().format('YYYY-MM-01'));
		this.employee_attendance = ko.observableArray();
		this.selected_department = ko.observable();
		this.current_department_id = ko.observableArray();
		this.leave_types = ko.observableArray();
		this.leave_type_id = ko.observable();
		this.loader = ko.observable(false);

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});

		this.leave_type_id.subscribe((newValue) => {
			this.page.updateData();
		});

		this.date_start_filter.subscribe((newValue) => {
			this.page.updateData();
		});
	}

	show_report_help()
	{
		Grape.dialog.open('EmployeeAttendanceInformationHelp', { employee_id: this.page.bindings.id });
	}

	async download_clicked(v, e)
	{
		let csv_string = await Utils.table_to_csv(document.getElementById('employee_attendance_report'));
		if (csv_string === null || csv_string === undefined || csv_string === '')
			return;
		
		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'employee_attendance_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

class EmployeeAttendancePage 
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EmployeeAttendanceViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeeAttendanceInfoReport'))
			return;

		document.title = tr('Employee Attendance Information');
		window.current_page_title(tr('Employee Attendance Information'));

		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'leave_type',
			sortfield: 'description',
			sortorder: 'asc',
			limit: 1000000
		});
		
		if (res)
			this.viewModel.leave_types(res.records);
	}

	updateData()
	{
		if (this.viewModel.current_department_id() != '' && this.viewModel.date_start_filter() != '' && this.viewModel.date_start_filter() != undefined)
			this.updateReportData();
	}

	async updateReportData()
	{
		let data = {
			department_id: this.viewModel.current_department_id(),
			date_start_filter: this.viewModel.date_start_filter(),
			leave_type_id: this.viewModel.leave_type_id()
		};

		this.viewModel.loader(true);

		let res = await Grape.fetches.postJSON('/reports/employee_attendace_report', data);
		
		if (res)
		{
			this.viewModel.employee_attendance(res);
			this.viewModel.loader(false);
		}
	}
}

export default {
	route: '[/]report/employee_attendance',
	page_class: EmployeeAttendancePage,
	template: template,
	template_filename: 'translation/employee_attendance_report'
};
